<template>
<div class="container">
    <!-- <div class="text_center">
            <img v-b-popover.hover.righttop="getMessageOfTheDay()" class="agatrs-logo" :src="this.GetAgatrsLogoUrl()" alt="AGATRS Logo" />
        </div>

        <div class="text_center black bold">ACSA GLOBAL AUTOMATED TRACKING & REPORTING SYSTEM</div> -->

    <h2 class="text_center more-top-padding black">{{this.$props.pageTitle}}</h2>
</div>
</template>

<script>
export default {
    name: "Header",
    props: ["pageTitle"],
    data() {
        return {

        }
    },
    methods: {
        getMessageOfTheDay() {
            return "Welcome to AGATRS v4.0 Beta!  Submit a helpdesk ticket (in website footer) to contact the AGATRS team about any questions on this release."
        },
        GetAgatrsLogoUrl() {
            const _host = window.location.host;
            const _base = process.env.BASE_URL;
            return (
                window.location.protocol + "//" + _host + _base + "img/agatrs_sm.jpg"
            );
        },
    },
};
</script>

<style scoped>
.agatrs-logo {
    width: 35%;
    height: auto;
}

h2,
.h2 {
    margin-bottom: 20px;
}
</style>
